(ns io.daskul.tutorial.webapp.views.conversation-thread.receipts
  "Outbound delivery/seen status for a message bubble — pure, no view deps
   (#223 slice 3). Extracted so it's unit-testable without the layout; the
   :node-test harness can't load view namespaces (React/Mantine), same reason as
   compose-state.

   sent → delivered → seen, from the recipient receipts the API stamps
   (:recipient-delivered-at / :recipient-seen-at). \"Seen\" (not \"read\")
   mirrors the API naming and Messenger's own term, and keeps it distinct from a
   message's staff-facing :state \"read\".")

(defn outbound-status
  "The delivery/seen status to show under an OUTBOUND message, or nil when there
   is nothing to show:

     :seen      — the recipient opened it (:recipient-seen-at set)
     :delivered — reached their device (:recipient-delivered-at set)
     :sent      — accepted by Meta, not yet acknowledged

   nil for inbound, and for outbound states that have their own affordance —
   pending (still sending) and failed (the failed bubble owns that). Seen implies
   delivered, so it wins."
  [{:keys [direction state recipient-delivered-at recipient-seen-at]}]
  (when (and (= direction "outbound") (= state "sent"))
    (cond
      recipient-seen-at :seen
      recipient-delivered-at :delivered
      :else :sent)))

(defn status-label
  "Short label for a status keyword (from outbound-status), or nil."
  [status]
  (case status
    :seen "Seen"
    :delivered "Delivered"
    :sent "Sent"
    nil))
